export default __webpack_public_path__ + "static/media/errors1.abf1f2cd.jpg";